// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import dayjs from 'dayjs'
import isNull from 'lodash/isNull'

import { displayNotification } from '../../../utils/notificiation-utils'
import { get } from '../../../utils/api-utils'

export const handleBellIconClick = ({
  trigger,
  setTrigger,
  rbacPolicies,
  notificationsRbac,
  isCCSManager,
  setShowNotification,
  navigate,
  t
}) => {
  setTrigger(!trigger)
  const showNotificationTab =
    rbacPolicies?.effects?.[notificationsRbac.resource]?.[
      notificationsRbac.permission
    ]

  if (isCCSManager && showNotificationTab) {
    navigate('/manage-ccs/notifications')
  } else if (isCCSManager && !showNotificationTab) {
    setShowNotification(
      displayNotification(
        t('notifications_permission_msg'),
        'error',
        setShowNotification
      )
    )
  } else {
    navigate('/notifications')
  }
}

export const startPolling = ({
  oidcUser,
  custAccountLoaded,
  LDFlags,
  setHasNew
}) => {
  let refreshPollTimer = null
  async function polling() {
    const lastInteractionTime = sessionStorage.getItem(
      'lastInteractionTimeLayout'
    )

    const diff = dayjs().diff(lastInteractionTime)

    if (diff < 60000 * 3 && !isNull(lastInteractionTime)) {
      refreshPollTimer = setTimeout(() => {
        polling()
      }, 60000 * 3 - diff)
    } else if (isNull(lastInteractionTime) || diff >= 60000 * 3) {
      if (
        oidcUser &&
        oidcUser?.access_token &&
        oidcUser?.access_token !== null &&
        custAccountLoaded !== null
      ) {
        let url = ''
        if (LDFlags['glcp-notifications-feature-alerts-tasks-kobe']) {
          url =
            '/notifications-svc/ui/v1alpha1/has-new-events?has_new_type=periodic'
        } else if (LDFlags['glcp-notifications-feature-edit-istanbul']) {
          url = '/notifications-svc/ui/v2/has-new?has_new_type=periodic'
        } else {
          url = '/notifications-svc/ui/v1alpha1/has-new?has_new_type=periodic'
        }
        get(url, {}, oidcUser?.access_token).then(
          (response) => {
            sessionStorage.setItem('lastInteractionTimeLayout', dayjs())
            polling()
            if (response?.data) {
              setHasNew(true)
            } else {
              setHasNew(false)
            }
          },
          (error) => {
            sessionStorage.setItem('lastInteractionTimeLayout', dayjs())
            polling()
            console.log(error)
            setHasNew(false)
          }
        )
      }
    }
  }

  polling()

  return () => {
    setHasNew(false) // cancelled all subscriptions and asynchronous tasks in a useEffect cleanup functions
    clearTimeout(refreshPollTimer)
  }
}
